import { BaseModel } from "sjs-base-model";
import ProdottoLightModel from "./ProdottoLightModel";
import SimulazioneModel from "./SimulazioneModel";

export default class SimulazioneExtendedModel extends BaseModel {
    public readonly prodotto: ProdottoLightModel | undefined = undefined;
    public readonly simulazione: SimulazioneModel | undefined = undefined;

    constructor(data: Partial<SimulazioneExtendedModel>) {
        super();
        this.update(data);
    }
}
